import { initializeApp } from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

Object.entries(firebaseConfig).forEach(([key, value]) => {
  if (!value || value === "XXX") {
    throw new Error(
      `Firebase configuration is missing key "${key}", please check your ".env" configuration file.`
    );
  }
});

const app = initializeApp(firebaseConfig);

// Připojení k Firestore
export const fireStore = getFirestore(app);
